/**
 * Cart Inventory Check
 * Prevents adding items to cart when out of stock at selected location
 * Shows modal with options to change address or switch to shipping
 */

(function() {
  'use strict';
  
  console.log('[Cart Inventory Check] Initializing...');
  
  // Store original Shopify functions
  var originalAddItemFromForm = window.Shopify && window.Shopify.addItemFromForm;
  var originalAddItem = window.Shopify && window.Shopify.addItem;
  
  /**
   * Check if variant is in stock at selected location
   */
  function checkInventoryAtLocation(variantId, locationId) {
    return new Promise(function(resolve, reject) {
      if (!variantId || !locationId) {
        resolve({ available: true }); // Allow if no location selected (shipping)
        return;
      }
      
      // Fetch inventory from backend API
      var backendUrl = window.BACKEND_API_URL || 'https://api.cascadepetsupply.com';
      var apiUrl = backendUrl + '/api/inventory-levels?variant_id=' + variantId;
      
      fetch(apiUrl)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Failed to fetch inventory');
          }
          return response.json();
        })
        .then(function(data) {
          if (data && data.inventory_levels) {
            // Find inventory for the selected location
            var locationInventory = data.inventory_levels.find(function(level) {
              return String(level.location_id || level.locationId) === String(locationId);
            });
            
            if (locationInventory) {
              var quantity = locationInventory.quantity || locationInventory.available || 0;
              resolve({
                available: quantity > 0,
                quantity: quantity,
                locationId: locationId
              });
            } else {
              // Location not found in inventory data, allow add to cart
              resolve({ available: true });
            }
          } else {
            // No inventory data, allow add to cart
            resolve({ available: true });
          }
        })
        .catch(function(error) {
          console.warn('[Cart Inventory Check] Error checking inventory:', error);
          // On error, allow add to cart (fail open)
          resolve({ available: true });
        });
    });
  }
  
  /**
   * Show modal with options to change address or switch to shipping
   */
  function showOutOfStockModal(variantId, locationName) {
    // Remove existing modal if any
    var existingModal = document.getElementById('out-of-stock-modal');
    if (existingModal) {
      existingModal.remove();
    }
    
    // Create overlay
    var overlay = document.createElement('div');
    overlay.id = 'out-of-stock-modal-overlay';
    overlay.style.cssText = 'position: fixed !important; top: 0 !important; left: 0 !important; width: 100vw !important; height: 100vh !important; background: rgba(0,0,0,0.5) !important; z-index: 100005 !important; display: flex !important; align-items: center !important; justify-content: center !important;';
    
    // Create modal
    var modal = document.createElement('div');
    modal.id = 'out-of-stock-modal';
    modal.style.cssText = 'background: white !important; border-radius: 8px !important; padding: 30px !important; max-width: 500px !important; width: 90% !important; box-shadow: 0 4px 20px rgba(0,0,0,0.3) !important; position: relative !important; z-index: 100006 !important;';
    
    // Title
    var title = document.createElement('h2');
    title.textContent = 'Out of Stock';
    title.style.cssText = 'margin: 0 0 15px 0; font-size: 24px; font-weight: 600; color: #d32f2f;';
    modal.appendChild(title);
    
    // Message
    var message = document.createElement('p');
    message.textContent = 'This item is currently out of stock at ' + (locationName || 'your selected location') + '.';
    message.style.cssText = 'margin: 0 0 25px 0; font-size: 16px; color: #333; line-height: 1.5;';
    modal.appendChild(message);
    
    // Options
    var options = document.createElement('div');
    options.style.cssText = 'display: flex; flex-direction: column; gap: 12px;';
    
    // Option 1: Change delivery address
    var changeAddressBtn = document.createElement('button');
    changeAddressBtn.textContent = 'Change Delivery Address';
    changeAddressBtn.style.cssText = 'padding: 12px 20px; background: #298029; color: white; border: none; border-radius: 4px; font-size: 16px; font-weight: 500; cursor: pointer; transition: background 0.2s;';
    changeAddressBtn.onmouseover = function() {
      this.style.background = '#1f5f1f';
    };
    changeAddressBtn.onmouseout = function() {
      this.style.background = '#298029';
    };
    changeAddressBtn.onclick = function() {
      overlay.remove();
      // Open location picker
      if (window.inventoryInfo && window.inventoryInfo.api && window.inventoryInfo.api.showLocationPicker) {
        window.inventoryInfo.api.showLocationPicker();
      } else if (typeof window.showLocationDropdown === 'function') {
        var activeBtn = document.querySelector('.header-method-btn[data-method="local_delivery"], .mobile-method-btn[data-method="local_delivery"]');
        window.showLocationDropdown(activeBtn);
      }
    };
    options.appendChild(changeAddressBtn);
    
    // Option 2: Switch to shipping
    var switchShippingBtn = document.createElement('button');
    switchShippingBtn.textContent = 'Switch to Shipping';
    switchShippingBtn.style.cssText = 'padding: 12px 20px; background: #0066cc; color: white; border: none; border-radius: 4px; font-size: 16px; font-weight: 500; cursor: pointer; transition: background 0.2s;';
    switchShippingBtn.onmouseover = function() {
      this.style.background = '#0052a3';
    };
    switchShippingBtn.onmouseout = function() {
      this.style.background = '#0066cc';
    };
    switchShippingBtn.onclick = function() {
      overlay.remove();
      // Switch to shipping method and update header to show "Online Warehouse"
      var switchToShipping = function() {
        // Find shipping button and click it
        var shippingBtn = document.querySelector('.header-method-btn[data-method="shipping"], .mobile-method-btn[data-method="shipping"]');
        if (shippingBtn) {
          shippingBtn.click();
        } else {
          // Fallback: set method directly
          window.currentMethod = 'shipping';
          if (window.StateManager && window.StateManager.setMethod) {
            window.StateManager.setMethod('shipping');
          }
          // Trigger method change event
          var event = new CustomEvent('methodChanged', { detail: { method: 'shipping' } });
          document.dispatchEvent(event);
        }
        
        // Update header text to "Online Warehouse" after a short delay
        setTimeout(function() {
          var onlineLocationLabel = (window.inventoryInfo && window.inventoryInfo.settings && window.inventoryInfo.settings.onlineLocationLabel) 
                                    ? window.inventoryInfo.settings.onlineLocationLabel 
                                    : 'Online Warehouse';
          
          // Update header location text
          var locationTextEl = document.querySelector('.location-picker-text');
          var locationTextElMobile = document.querySelector('.location-picker-text-mobile');
          
          if (locationTextEl && locationTextEl.textContent !== onlineLocationLabel) {
            locationTextEl.textContent = onlineLocationLabel;
          }
          if (locationTextElMobile && locationTextElMobile.textContent !== onlineLocationLabel) {
            locationTextElMobile.textContent = onlineLocationLabel;
          }
          
          // Also try to select online location if available
          if (window.inventoryInfo && window.inventoryInfo.api && window.inventoryInfo.api.selectLocation) {
            var onlineLocationId = window.inventoryInfo.settings && window.inventoryInfo.settings.onlineLocation;
            if (onlineLocationId) {
              window.inventoryInfo.api.selectLocation(onlineLocationId).then(function() {
                console.log('[Cart Inventory Check] Selected online warehouse location');
              }).catch(function(error) {
                console.warn('[Cart Inventory Check] Error selecting online location:', error);
              });
            } else {
              // Clear selected location if no online location ID
              if (window.inventoryInfo.selectedLocation) {
                window.inventoryInfo.selectedLocation = null;
              }
              if (window.inventoryInfo.api.getSelectedLocationId) {
                // Clear from localStorage
                try {
                  localStorage.removeItem('selectedLocationId');
                } catch(e) {}
              }
            }
          }
          
          // Call updateHeaderText if available
          if (typeof window.updateHeaderText === 'function') {
            window.updateHeaderText(onlineLocationLabel);
          }
        }, 100);
      };
      
      if (window.currentMethod && window.currentMethod !== 'shipping') {
        switchToShipping();
      } else {
        // Already on shipping, just update the header
        switchToShipping();
      }
    };
    options.appendChild(switchShippingBtn);
    
    // Cancel button
    var cancelBtn = document.createElement('button');
    cancelBtn.textContent = 'Cancel';
    cancelBtn.style.cssText = 'padding: 12px 20px; background: #f5f5f5; color: #333; border: 1px solid #ddd; border-radius: 4px; font-size: 16px; font-weight: 500; cursor: pointer; transition: background 0.2s;';
    cancelBtn.onmouseover = function() {
      this.style.background = '#e0e0e0';
    };
    cancelBtn.onmouseout = function() {
      this.style.background = '#f5f5f5';
    };
    cancelBtn.onclick = function() {
      overlay.remove();
    };
    options.appendChild(cancelBtn);
    
    modal.appendChild(options);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    
    // Close on overlay click
    overlay.onclick = function(e) {
      if (e.target === overlay) {
        overlay.remove();
      }
    };
    
    // Close on Escape key
    var escapeHandler = function(e) {
      if (e.key === 'Escape') {
        overlay.remove();
        document.removeEventListener('keydown', escapeHandler);
      }
    };
    document.addEventListener('keydown', escapeHandler);
  }
  
  /**
   * Get variant ID from form
   */
  function getVariantIdFromForm(form) {
    if (!form) return null;
    
    // Try hidden input first
    var hiddenInput = form.querySelector('input[name="id"][type="hidden"]');
    if (hiddenInput) {
      return parseInt(hiddenInput.value, 10);
    }
    
    // Try variant selector
    var variantSelect = form.querySelector('select[name="id"]');
    if (variantSelect) {
      return parseInt(variantSelect.value, 10);
    }
    
    return null;
  }
  
  /**
   * Intercept add to cart
   */
  function interceptAddToCart(variantId, callback) {
    // Get current method and location
    var currentMethod = window.currentMethod || 'shipping';
    
    // Only check inventory for local_delivery and local_pickup
    if (currentMethod === 'local_delivery' || currentMethod === 'local_pickup') {
      // Get selected location ID (might be a Promise)
      var locationIdPromise = null;
      if (window.inventoryInfo && window.inventoryInfo.api && window.inventoryInfo.api.getSelectedLocationId) {
        locationIdPromise = window.inventoryInfo.api.getSelectedLocationId();
      }
      
      // Handle both Promise and direct value
      var handleLocationId = function(selectedLocationId) {
        if (selectedLocationId) {
          // Check inventory at selected location
          checkInventoryAtLocation(variantId, selectedLocationId).then(function(result) {
            if (!result.available) {
              // Out of stock - show modal
              var locationName = 'your selected location';
              if (window.inventoryInfo && window.inventoryInfo.selectedLocation) {
                locationName = window.inventoryInfo.selectedLocation.name || locationName;
              } else if (window.inventoryInfo && window.inventoryInfo.api && window.inventoryInfo.api.getSelectedLocation) {
                var locPromise = window.inventoryInfo.api.getSelectedLocation();
                if (locPromise && typeof locPromise.then === 'function') {
                  locPromise.then(function(loc) {
                    if (loc && loc.name) {
                      locationName = loc.name;
                    }
                    showOutOfStockModal(variantId, locationName);
                  }).catch(function() {
                    showOutOfStockModal(variantId, locationName);
                  });
                  return; // Don't proceed with add to cart
                } else if (locPromise && locPromise.name) {
                  locationName = locPromise.name;
                }
              }
              showOutOfStockModal(variantId, locationName);
              // Don't proceed with add to cart
              return;
            } else {
              // In stock - proceed with add to cart
              callback();
            }
          }).catch(function(error) {
            console.warn('[Cart Inventory Check] Error checking inventory, allowing add to cart:', error);
            // On error, allow add to cart (fail open)
            callback();
          });
        } else {
          // No location selected - allow add to cart (will prompt for location)
          callback();
        }
      };
      
      // Check if locationIdPromise is a Promise
      if (locationIdPromise && typeof locationIdPromise.then === 'function') {
        locationIdPromise.then(function(locationId) {
          handleLocationId(locationId);
        }).catch(function(error) {
          console.warn('[Cart Inventory Check] Error getting location ID, allowing add to cart:', error);
          // On error, allow add to cart
          callback();
        });
      } else {
        // Direct value
        handleLocationId(locationIdPromise);
      }
    } else {
      // Shipping method - always allow add to cart
      callback();
    }
  }
  
  // Override Shopify.addItemFromForm
  if (originalAddItemFromForm) {
    window.Shopify.addItemFromForm = function(formIdOrElement) {
      // Handle both string ID and element
      var form = null;
      var formId = null;
      
      if (typeof formIdOrElement === 'string') {
        formId = formIdOrElement;
        form = document.getElementById(formId) || document.querySelector('form[action*="/cart/add"]');
      } else if (formIdOrElement && formIdOrElement.nodeType === 1) {
        // It's an element
        form = formIdOrElement;
        formId = form.id || form.getAttribute('id') || 'product-form';
      } else {
        // Try to find form
        form = document.querySelector('form[action*="/cart/add"]');
        formId = form ? (form.id || 'product-form') : 'product-form';
      }
      
      if (!form) {
        console.warn('[Cart Inventory Check] Form not found, using original function');
        return originalAddItemFromForm.call(this, formIdOrElement);
      }
      
      var variantId = getVariantIdFromForm(form);
      if (!variantId) {
        console.warn('[Cart Inventory Check] Variant ID not found in form, using original function');
        return originalAddItemFromForm.call(this, formIdOrElement);
      }
      
      interceptAddToCart(variantId, function() {
        // Ensure we pass the correct form ID (string) to the original function
        var finalFormId = formId;
        if (!finalFormId || finalFormId === '') {
          finalFormId = form.id || 'product-form';
        }
        
        // Ensure it's a string
        finalFormId = String(finalFormId);
        
        if (originalAddItemFromForm) {
          try {
            originalAddItemFromForm.call(window.Shopify, finalFormId);
          } catch (err) {
            console.warn('[Cart Inventory Check] Error calling originalAddItemFromForm, submitting form directly:', err);
            form.submit();
          }
        } else {
          form.submit();
        }
      });
    };
  }
  
  // Override Shopify.addItem
  if (originalAddItem) {
    window.Shopify.addItem = function(variantId, quantity) {
      interceptAddToCart(variantId, function() {
        originalAddItem.call(window.Shopify, variantId, quantity);
      });
    };
  }
  
  // Also intercept form submissions directly
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
      e.preventDefault();
      e.stopPropagation();
      
      var variantId = getVariantIdFromForm(form);
      if (!variantId) {
        // If no variant ID, allow default form submission
        form.submit();
        return;
      }
      
      interceptAddToCart(variantId, function() {
        // Proceed with form submission
        form.submit();
      });
    }
  }, true); // Use capture phase to intercept before other handlers
  
  // Also intercept button clicks on add to cart buttons
  document.addEventListener('click', function(e) {
    var target = e.target;
    var button = target.closest('.addtocart-js, .btn-addtocart, .addtocart-item-js');
    
    if (button && !button.disabled && !button.classList.contains('disable')) {
      var form = button.closest('form');
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
        var variantId = getVariantIdFromForm(form);
        if (variantId) {
          e.preventDefault();
          e.stopPropagation();
          
          interceptAddToCart(variantId, function() {
            // Trigger the original button click or form submission
            if (button.classList.contains('addtocart-js')) {
              // Use Shopify.addItemFromForm - ensure we have a valid form ID
              var formId = form.id;
              if (!formId || formId === '') {
                // If form has no ID, submit directly
                form.submit();
                return;
              }
              
              // Ensure formId is a string
              formId = String(formId);
              
              if (originalAddItemFromForm) {
                // Use the original function directly to avoid recursion
                try {
                  originalAddItemFromForm.call(window.Shopify, formId);
                } catch (err) {
                  console.warn('[Cart Inventory Check] Error calling originalAddItemFromForm, submitting form directly:', err);
                  form.submit();
                }
              } else {
                form.submit();
              }
            } else if (button.classList.contains('addtocart-item-js')) {
              // Use Shopify.addItem
              if (originalAddItem) {
                try {
                  originalAddItem.call(window.Shopify, variantId, 1);
                } catch (err) {
                  console.warn('[Cart Inventory Check] Error calling originalAddItem, submitting form directly:', err);
                  form.submit();
                }
              } else {
                form.submit();
              }
            } else {
              form.submit();
            }
          });
        }
      }
    }
  }, true); // Use capture phase
  
  console.log('[Cart Inventory Check] Initialized and intercepting add to cart');
})();

